import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import WavePickTask from "./WavePickTask.vue";
import {
  compareLocation,
  getUniquePickTasksBasedOnSku,
} from "@/store/wavePicking/helpers";
import { PickTask, usePickStore } from "@/stores/tasks/pick-tasks";
import { onBeforeRouteLeave, useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'WavePickTasks',
  setup(__props) {

const router = useRouter();
const pickStore = usePickStore();
const enableRouteLeave = ref<boolean>(false);

onBeforeRouteLeave((to, _from, next) => {
  const exitRoutes = ["wave_pick_totes", "wave_pick_complete"];
  if (to.name && exitRoutes.includes(to.name) && enableRouteLeave.value) {
    next();
  } else {
    next(false);
  }
});

// computed
const wavePickingTasks = computed(() => {
  return pickStore.getters.getTasks;
});

const taskItemsVisible = computed(() => {
  return !!wavePickingTasks.value.length;
});

function uniqueWavePickingTasks(): PickTask[] {
  const deepClone = JSON.parse(JSON.stringify(wavePickingTasks.value));
  const consolidatedTasks = getUniquePickTasksBasedOnSku(deepClone);
  return consolidatedTasks.sort(compareLocation);
}

const hasOutstandingTasks = computed(() => {
  return (
    wavePickingTasks?.value?.filter((task) => task.status === "new").length > 0
  );
});

watch(
  hasOutstandingTasks,
  (hasTasks) => {
    if (!hasTasks) {
      enableRouteLeave.value = true;
      router.push({ name: "wave_pick_complete" });
    }
  },
  { immediate: true }
);

return { __sfc: true,router, pickStore, enableRouteLeave, wavePickingTasks, taskItemsVisible, uniqueWavePickingTasks, hasOutstandingTasks, WavePickTask }
}

})